import { render, staticRenderFns } from "./detailEvent.vue?vue&type=template&id=ae0d03ac&scoped=true"
import script from "./detailEvent.vue?vue&type=script&lang=js"
export * from "./detailEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0d03ac",
  null
  
)

export default component.exports